// extracted by mini-css-extract-plugin
export default {"orders":"OrdersInfo_orders__WCDTg"};